import { TextField } from '@boltenergy-be/design-system'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'next-i18next/pages'
import { NO_NUMBERS } from 'constants/regex'
import { InputProps } from 'components/inputs/types'
import { getFieldError, getFieldName } from 'components/inputs/utils'

const FirstName = ({ hiddenLabel, parentDotPath, required = true, grid, readonly }: InputProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  return (
    <TextField
      {...{ grid, hiddenLabel, readonly }}
      {...register(getFieldName('firstName', parentDotPath), {
        maxLength: {
          value: 40,
          message: t('validation:max.string', {
            attribute: t('commonFormFields:firstName'),
            length: 40
          })
        },
        minLength: {
          value: 2,
          message: t('validation:min.string', {
            attribute: t('commonFormFields:firstName'),
            length: 2
          })
        },
        required: {
          value: required,
          message: t('validation:required')
        },
        pattern: {
          value: NO_NUMBERS,
          message: t('validation:noNumbers', {
            attribute: t('commonFormFields:firstName')
          })
        }
      })}
      error={getFieldError('firstName', parentDotPath, errors)?.message}
      label={t('commonFormFields:firstName')}
      {...(!required && { optionalText: t('common:optional') })}
    />
  )
}

export default FirstName
